// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/implication.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file inventory/v1/implication.proto.
 */
export const file_inventory_v1_implication: GenFile = /*@__PURE__*/
  fileDesc("Ch5pbnZlbnRvcnkvdjEvaW1wbGljYXRpb24ucHJvdG8SDGludmVudG9yeS52MSqtAQoLSW1wbGljYXRpb24SGwoXSU1QTElDQVRJT05fVU5TUEVDSUZJRUQQABIaChZJTVBMSUNBVElPTl9DT01QTElBTkNFEAESHQoZSU1QTElDQVRJT05fQlJFQUNIX0lNUEFDVBACEiEKHUlNUExJQ0FUSU9OX0JSRUFDSF9MSUtFTElIT09EEAMSIwofSU1QTElDQVRJT05fQlVTSU5FU1NfQ09OVElOVUlUWRAEQrgBChBjb20uaW52ZW50b3J5LnYxQhBJbXBsaWNhdGlvblByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z");

/**
 * @generated from enum inventory.v1.Implication
 */
export enum Implication {
  /**
   * @generated from enum value: IMPLICATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMPLICATION_COMPLIANCE = 1;
   */
  COMPLIANCE = 1,

  /**
   * @generated from enum value: IMPLICATION_BREACH_IMPACT = 2;
   */
  BREACH_IMPACT = 2,

  /**
   * @generated from enum value: IMPLICATION_BREACH_LIKELIHOOD = 3;
   */
  BREACH_LIKELIHOOD = 3,

  /**
   * @generated from enum value: IMPLICATION_BUSINESS_CONTINUITY = 4;
   */
  BUSINESS_CONTINUITY = 4,
}

/**
 * Describes the enum inventory.v1.Implication.
 */
export const ImplicationSchema: GenEnum<Implication> = /*@__PURE__*/
  enumDesc(file_inventory_v1_implication, 0);

